<div class="menu-options flexRowParent">
    <div *ngFor="let section of sections; let last = last;" class="section">
        <div class="flexColumnParent">
            <div class="actions-title flexItem">{{section.sectionTitle}}</div>
            <div class="actions flexColumnParent flexItemBiggest">
                <div *ngFor="let action of section.sectionActions"
                     (click)="onAction.emit(action);action.callback && action.callback()"
                     class="action flexRowParent">

                    <span class="action-message" class="{{action.message | acFunc: createActionClass}}">{{action.message | titlecase}}</span>

                    <ng-container
                            *ngTemplateOutlet="action.acComponent?.template; context: action.acComponent?.context"></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
